class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

     /*=================================================
      Grid View Js Start
    =================================================*/

    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + value + expires + "; path=/";
    }

    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }
    /*
    var elem = $('ul.product-grid');
    $('.list-grid-view a').on('click', function (e) {
      e.preventDefault();

      if ($(this).hasClass('gridview')) {
        elem.fadeOut(250, function () {
          elem.removeClass('list').addClass('grid-view-box');
          setCookie("viewProduct", "grid", 7);
          elem.fadeIn(250);
        });
      } else if ($(this).hasClass('listview')) {
        elem.fadeOut(250, function () {
          elem.removeClass('grid-view-box').addClass('list');
          setCookie("viewProduct", "list", 7);
          elem.fadeIn(250);
        });
      }

      disableScroll = true;

      setTimeout(function () {
        disableScroll = false;
      }, 100);
    });
    if ($('.list-grid-view').length) {
      $(document).on('click', '.list-grid-view a', (e) => {
        $('.list-grid-view a').removeClass('active');
        const currentTarget = $(e.currentTarget).data('view-val');
        $(e.currentTarget).addClass('active');

        switch (currentTarget) {
          case 'product-grid-view':
            $('.product-grid').removeClass('product-list-style');
            $('.product-grid').addClass(currentTarget);
            setCookie("viewProduct", "grid", 7);
            break;
          case 'product-list-style':
            $('.product-grid').removeClass('product-grid-view');
            $('.product-grid').addClass(currentTarget);
            setCookie("viewProduct", "list", 7);
            break;
          default:
        }
      });
    }
*/
    // $(document).ready(function () {
    //   var userValue = getCookie("viewProduct");
    //   if (userValue == 'grid') {
    //     console.log("Setting grid view");
    //     elem.removeClass('list').addClass('grid-view-box');
    //     $(".list-grid-view li a.gridview").addClass("active");
    //   } else {
    //     console.log("Setting list view");
    //     elem.removeClass('grid-view-box').addClass('list');
    //     $(".list-grid-view li a.listview").addClass("active");
    //   }
    // });

    // $(document).ready(function () {
    //   var userValue = getCookie("viewProduct");
    //   if (userValue == 'list') {
    //     elem.removeClass('grid-view-box').addClass('list');
    //     $(".list-grid-view li a.listview").addClass("active");
    //   } else {
    //     elem.removeClass('list').addClass('grid-view-box');
    //     $(".list-grid-view li a.gridview").addClass("active");
    //   }
    // });

    // Handle the scroll event
    $(window).scroll(function () {
      if (disableScroll) {
        $(this).scrollTop(0);
        disableScroll = false;
      }
    });
    /*=================================================
      Grid View Js End
    =================================================*/

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }


  static renderPage(searchParams, event, updateURLHash = true) {
    
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) { 
      FacetFiltersForm.updateURLHash(searchParams);
      // FacetFiltersForm.updatePaginationLinks(searchParams);
    }

  
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        console.log(url);
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        window.makeSelect2Dropdowns('.facet-filters__sort:not([data-select2-id])');
        var userValue = getCookie("viewProduct");
        if (userValue == 'list') {
            $('.listview').click(); 
        } else {
            $('.gridview').click();
        }
        //slider call here
        showColorFilterSlider();
      //  window.makeSelect2Dropdowns('.select__select:not([data-select2-id])');
        // var searchParams = new URLSearchParams(window.location.search);
        // updatePaginationLinks(searchParams);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    window.makeSelect2Dropdowns('.facet-filters__sort:not([data-select2-id])');
    var userValue = getCookie("viewProduct");
    if (userValue == 'list') {
      $('.listview').click();
    } else {
      $('.gridview').click();
    }
//    window.makeSelect2Dropdowns('.select__select:not([data-select2-id])');
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    //update pagination links
    var searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('page');
    document
      .querySelectorAll('.pagination__item')
      .forEach((element) => {
        var newURL = element.href + '&' + searchParams;
        console.log("updating pagination links");
        element.href = newURL;
  });
    
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetsHTML = parsedHTML.querySelector('.facets-container').innerHTML;
    document.querySelector('.facets-container').innerHTML = facetsHTML;
    
    // const facetDetailsElements = parsedHTML.querySelectorAll(
    //   '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    // );
    // const matchesIndex = (element) => {
    //   const jsFilter = event ? event.target.closest('.js-filter') : undefined;
    //   return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    // };
    // const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    // const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    // facetsToRender.forEach((element) => {
    //   document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;

    // });

    // FacetFiltersForm.renderActiveFacets(parsedHTML);
    // FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // if (countsToRender) {
    //   const closestJSFilterID = event.target.closest('.js-filter').id;

    //   if (closestJSFilterID) {
    //     FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    //     FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

    //     const newElementSelector = document
    //       .getElementById(closestJSFilterID)
    //       .classList.contains('mobile-facets__details')
    //       ? `#${closestJSFilterID} .mobile-facets__close-button`
    //       : `#${closestJSFilterID} .facets__summary`;
    //     const newElementToActivate = document.querySelector(newElementSelector);
    //     if (newElementToActivate) newElementToActivate.focus();
    //   }
    // }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      console.log(activeFacetsElement);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    console.log(formData);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      window.makeSelect2Dropdowns('.facet-filters__sort:not([data-select2-id])');
              //   window.makeSelect2Dropdowns('.select__select:not([data-select2-id])');
              // Example: Read the value of the "user" cookie
            var userValue = getCookie("viewProduct");
            if (userValue == 'list') {
              $('.listview').click();
            } else {
              $('.gridview').click();
            }
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/*===================================================
          FilterSlider Js Start
    =====================================================*/

    jQuery(function(){
      showColorFilterSlider();
    });

    function showColorFilterSlider() {
      var $slider = $('#slick-colors'); // Cache the slider
       // Destroy and reinitialize Slick
        // Initialize Slick
        $slider.slick({
          slidesToShow: 5, // Number of visible slides
          slidesToScroll: 1,
          infinite: true, // Enable infinite looping
          arrows: true, // Navigation arrows
          dots: false, // No dots under the slider
          autoplay: true, // Enable auto-slide
          autoplaySpeed: 2000, // Time between slides
          responsive: [
            {
              breakpoint: 1024, // Medium screens
              settings: { slidesToShow: 3 }
            },
            {
              breakpoint: 768, // Small screens
              settings: { slidesToShow: 2 }
            },
            {
              breakpoint: 480, // Mobile
              settings: { slidesToShow: 1 }
            }
          ]
        }); 
        $('#outputDiv2').show(); // Show the slider once initialized
  }
  
  /*=================================================
      FilterSlider Js End
    =================================================*/
